import _getIterator from 'babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Presentation from './Items/Presentation';
import User from './Items/User';
import Person from './Items/Person';
import Question from './Items/Question';
import Slide from './Items/Slide';
import XHRPromise from './Utils/XHRPromise';
import BroadcastManager from './WebSockets/BroadcastManager';
import Message from './Items/Message';
import Contact from './Items/Contact';
import Survey from './Items/Survey';
import cookie from './Utils/Cookie';
import Identifier from './Utils/Identifier';
import DLog from './Utils/DLog';
import Url from './Utils/Url';
import StringEx from './Utils/StringEx';

var defaultBaseUrl = 'api.dialogloop.com';
var registerBearer = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3MiOiJhZGRfdXNlciIsImV4cCI6MTU4Mjk0MzY4NywiaXNzIjoiZGlhbG9nbG9vcC5jb20ifQ.FczSvQOd7-QsVY95-gKTpQ9RoALU7k0Vbh51gb26kU95TyqQDbyUtgG-vBeax_gTK0yTLO1v8jDOAQHzQdx9troDCRm0c8HeWI0_YHDYKl0Qov-nIdEgvNtjwJ8FJy8K0lv3_M9X_UzofGjDGPr1Z9_d6-WgSOwo3ufoszwbcEs';

var DLService = function () {

    /**
     * @description Initializes a new service object 
     * @param {string} host
     * @param {string} version
     */
    function DLService() {
        var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBaseUrl;
        var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';

        _classCallCheck(this, DLService);

        console.log('Using host: ' + host + ', version: ' + version);

        this.dlog = new DLog();
        this.apiOptions = {
            host: host,
            version: version,
            auth: ''
        };
        this.cache = {};
    }

    /**
     * @description Register a new user
     * @param {string} firstname
     * @param {string} lastname
     * @param {string} email
     * @param {string} password
     * @return Promise
     */


    _createClass(DLService, [{
        key: 'registerUser',
        value: function registerUser(firstname, lastname, email, password) {
            var _this = this;

            if (!firstname || !lastname || !StringEx.isValidEmailFormat(email) || !password || firstname.trim() === '' || lastname.trim() === '' || password.trim() === '') {
                this.dlog.error('DLService.registerUser: Invalid argument');
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.registerUser with: ' + firstname + ', ' + lastname + ', ' + email + ', ' + password);

            return new _Promise(function (resolve, reject) {
                var xhrp = new XHRPromise('POST', 'https://' + defaultBaseUrl + '/v1/users');

                xhrp.addHeaders({
                    Authorization: 'Bearer ' + registerBearer
                });

                xhrp.addPayload(_JSON$stringify({
                    name: firstname + ' ' + lastname,
                    firstname: firstname,
                    lastname: lastname,
                    username: email,
                    email: email,
                    password: password
                }), 'application/json; charset=UTF-8');

                xhrp.createAndSend().then(resolve).catch(function (err) {
                    err = _JSON$stringify(err);
                    _this.dlog.error('DLService.registerUser - Request error: ' + err);
                    reject({
                        code: 404,
                        message: err
                    });
                });
            });
        }

        /**
         * \brief   Login to social network or DialogLoop
         * \param[in] socialNetwork     Social network associated to login url: linked, twitter, facebook, dialogloop
         * \param[in] url   Optional Current url
         * \param[in] email  Optional Email of the user to log in
         * \param[in] password  Optional Password associated
         * \return Promise
         */

    }, {
        key: 'login',
        value: function login(socialNetwork, url, email, password) {
            var _this2 = this;

            socialNetwork = socialNetwork.toLowerCase();

            if (socialNetwork !== 'linkedin' && socialNetwork !== 'twitter' && socialNetwork !== 'facebook' && socialNetwork !== 'dialogloop') {
                this.dlog.error('DLService.login: Invalid argument: ' + socialNetwork);
                return _Promise.reject("Invalid arguments");
            }

            if (socialNetwork === 'dialogloop' && (!email || !password || email.trim() === '' || password.trim() === '')) {
                this.dlog.error('DLService.login: Invalid arguments to login to DialogLoop. Provide an email and password');
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.login with: ' + socialNetwork + ', ' + email + ', ' + password);

            return new _Promise(function (resolve, reject) {
                if (socialNetwork === 'dialogloop') {
                    var params = Url.paramsArray(Url.removeParam(url, "error_code"));

                    params.push(_this2.getRdParameter());

                    var formEl = document.createElement("form");
                    formEl.style.display = "none";
                    formEl.setAttribute("method", "post");
                    formEl.setAttribute("action", 'https://' + defaultBaseUrl + '/authorize');

                    var sEl = document.createElement("input");
                    sEl.setAttribute("name", "s");
                    sEl.setAttribute("value", params.join('&'));
                    formEl.appendChild(sEl);

                    var emailEl = document.createElement("input");
                    emailEl.setAttribute("name", "email");
                    emailEl.setAttribute("value", email);
                    formEl.appendChild(emailEl);

                    var passwordEl = document.createElement("input");
                    passwordEl.setAttribute("name", "password");
                    passwordEl.setAttribute("value", password);
                    formEl.appendChild(passwordEl);

                    document.body.appendChild(formEl);
                    formEl.submit();
                } else {
                    window.location.href = _this2.getLoginUrl(socialNetwork, url);
                }
            });
        }

        /**
         * \brief   Set log level to print in the console.
         * \param[in] level Level of logs to print: NONE = 0, ERROR = 1, WARNING = 2, INFO = 3, DEBUG = 4
         */

    }, {
        key: 'setLogLevel',
        value: function setLogLevel(level) {
            this.dlog.level = level;
        }

        /**
         * @description Join the user to the sessions
         * \param[in] {object} connection   Details of the connection.
         * \return Promise if user data. If we cannot join, we return an error.
         *         Error code is 401 if we require the application to show a login page.
         * \example
         * this.service.login({
         *   url: window.location.href
         * }).then((user) => {
         *   this.user = user;
         *   this.init();
         * }).catch((err) => {
         *   if (err.code === 401) {
         *     console.log('Show login page with social network selection to get user ID from server');
         *   } else {
         *     console.error(err);
         *   }
         * });
         */

    }, {
        key: 'join',
        value: function join(connection) {
            var _this3 = this;

            if (connection === undefined) {
                return _Promise.reject({
                    code: 400,
                    message: "Invalid arguments"
                });
            }

            var userId = connection.userId ? connection.userId : Url.getParam(connection.url, "userId");

            if (userId === undefined) {
                return _Promise.reject({
                    code: 401,
                    message: "No user Id. Redirect to login page."
                });
            }

            this.dlog.debug('DLService.join with connection ' + _JSON$stringify(connection));

            var auth = cookie.get("DialoopKey");

            if (!auth) {
                var testAuth = connection.testAuth ? connection.testAuth : Url.getParam(connection.url, 'testAuth');

                if (!testAuth) {
                    this.dlog.error('DLService.join - Could not get authentication key DialoopKey');

                    return _Promise.reject({
                        code: 404,
                        message: "Missing DialogLoopKey cookie"
                    });
                }

                auth = testAuth;
            }

            this.dialogLoopKey = auth;

            return new _Promise(function (resolve, reject) {
                var url = 'https://' + _this3.apiOptions.host + '/' + _this3.apiOptions.version + '/user/' + userId;
                var xhrp = new XHRPromise('GET', url);

                xhrp.addHeaders({
                    Authorization: 'Bearer ' + auth
                });

                xhrp.createAndSend().then(function (response) {
                    var user = new User(JSON.parse(response.responseText).data);
                    _this3.apiOptions.auth = 'Bearer ' + user.token;
                    resolve(user);
                }).catch(function (err) {
                    err = _JSON$stringify(err);
                    _this3.dlog.error('DLService.login - Request error: ' + err);
                    reject({
                        code: 404,
                        message: err
                    });
                });
            });
        }

        /**
         * \brief Get connection details
         * \return Promise with string details of the connection
         */

    }, {
        key: 'getConnection',
        value: function getConnection(url) {
            var _this4 = this;

            this.dlog.debug('DLService.getConnection with url ' + url);

            return new _Promise(function (resolve, reject) {
                _this4.getSession({
                    url: url
                }).then(function (handle) {
                    var result = {
                        dialogloopkey: _this4.dialogLoopKey,
                        token: _this4.apiOptions.auth
                    };

                    if (handle.session) {
                        result.session = handle.session;
                    } else if (data.presentation) {
                        result.presentation = handle.presentation;
                    }

                    resolve(result);
                }).catch(reject);
            });
        }

        /**
         * \brief  Get the details of the session
         * \params[in] connection Details of the connection.
         * \return Promise with the handle to the session or the presentation
         * \example
         * DLService.getSession({
         *   url: window.location.href
         * }).then(async (handle) => {
         *   if (handle.session) {
         *     this.presentationList = await this.getPresentations(this.$route.query.handle);
         *   } else if (handle.presentation) {
         *     this.presentation = await this.service.getPresentation(this.$route.query.s);
         *   } else {
         *     console.error("An unexpected error has occured");
         *   }
         * });
         */

    }, {
        key: 'getSession',
        value: function getSession(connection) {
            var _this5 = this;

            if (!connection) {
                this.dlog.error("DLService.getSession - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            return new _Promise(function (resolve, reject) {
                _this5.dlog.debug('DLService.getSession with connection: ' + _JSON$stringify(connection));

                var userId = connection.userId ? connection.userId : Url.getParam(connection.url, 'userId');
                var s = connection.s ? connection.s : Url.getParam(connection.url, 's');
                var handle = connection.handle ? connection.handle : Url.getParam(connection.url, 'handle');
                var shortCodeFull = connection.shortCode ? connection.shortCode : Url.getParam(connection.url, 'shortCode');
                var exp = connection.exp ? connection.exp : Url.getParam(connection.url, 'exp');
                var testAuth = connection.testAuth ? connection.testAuth : Url.getParam(connection.url, 'testAuth');

                function resolveData() {
                    if (s === undefined) {
                        resolve({
                            session: handle
                        });
                    } else {
                        resolve({
                            presentation: s
                        });
                    }
                }

                if (shortCodeFull === undefined) {
                    resolveData();
                    return;
                }

                var shortCodeUrl = decodeURIComponent(shortCodeFull);
                var shortCode = shortCodeUrl.substr(shortCodeUrl.lastIndexOf('/') + 1);

                _this5.dlog.debug('DLService.getSession decode url with shortCode: ' + shortCodeUrl);

                _this5.authenticatedRequest('c/' + shortCode, 'GET', 'JSON', {
                    host: "https://dialog.live"
                }).then(function (shortCodeData) {
                    _this5.dlog.debug('DLService.getSession shortCode has returned with: ' + _JSON$stringify(shortCodeData));

                    if (shortCodeData && shortCodeData.exists && shortCodeData.url && Url.getParam(shortCodeData.url, 'state') !== 'Deleted') {
                        s = Url.getParam(shortCodeData.url, 's');
                        handle = Url.getParam(shortCodeData.url, 'handle', Url.getParam(shortCodeData.url, 'h'));
                    }

                    resolveData();
                }).catch(function (err) {
                    _this5.dlog.error('Unable to get the data for the the shortCode: ' + shortCode);
                    reject('Invalid response from the server');
                });
            });
        }

        /**
         * \brief   Get user profile
         * \param[in] userId    User Id
         * \return User profile on success, else undefined
         * \return Promise
         */

    }, {
        key: 'getUser',
        value: function getUser(userId) {
            var _this6 = this;

            if (userId === undefined) {
                this.dlog.error("DLService.getUser - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.getUser with user Id: ' + userId);

            return new _Promise(function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                    var response;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this6.authenticatedRequest('user/' + userId);

                                case 2:
                                    response = _context.sent;

                                    if (response) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _this6.dlog.error('Unable to get the user with Id: ' + userId);
                                    reject('Unable to get the user');
                                    return _context.abrupt('return');

                                case 7:

                                    resolve(new User(response.data));

                                case 8:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this6);
                }));

                return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                };
            }());
        }

        /**
         * \brief   Get all presentations in the session
         * \param[in] sessionId    Id of the session
         * \return Array of Presentation objects on success, else undefined
         */

    }, {
        key: 'getPresentations',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sessionId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(sessionId === undefined)) {
                                    _context2.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPresentations - Invalid arguments");
                                return _context2.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPresentations with session Id: ' + sessionId);

                                _context2.next = 6;
                                return this.authenticatedRequest('presentations', 'GET', 'JSON', {
                                    params: {
                                        handle: sessionId
                                    }
                                });

                            case 6:
                                response = _context2.sent;

                                if (!(!response || !response.data || !response.data.Presentations)) {
                                    _context2.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the user with Id: ' + userId);
                                return _context2.abrupt('return');

                            case 10:
                                return _context2.abrupt('return', response.data.Presentations.map(function (pres) {
                                    return new Presentation(pres);
                                }));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getPresentations(_x5) {
                return _ref2.apply(this, arguments);
            }

            return getPresentations;
        }()

        /**
         * \brief   Get description of the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Presentation object on success, else undefined
         */

    }, {
        key: 'getPresentation',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(presentationId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context3.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPresentation - Invalid arguments");
                                return _context3.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPresentation with presentation Id: ' + presentationId);

                                _context3.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId);

                            case 6:
                                response = _context3.sent;

                                if (response) {
                                    _context3.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the presentation with Id: ' + presentationId);
                                return _context3.abrupt('return');

                            case 10:
                                return _context3.abrupt('return', new Presentation(response.data));

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getPresentation(_x6) {
                return _ref3.apply(this, arguments);
            }

            return getPresentation;
        }()

        /**
         * \brief   Get people in the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Person objects on success, else undefined
         */

    }, {
        key: 'getPeople',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(presentationId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context4.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getPeople - Invalid arguments");
                                return _context4.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getPeople with presentation Id: ' + presentationId);

                                _context4.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/people');

                            case 6:
                                response = _context4.sent;

                                if (!(!response || !response.data)) {
                                    _context4.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the people in the presentation with Id: ' + presentationId);
                                return _context4.abrupt('return');

                            case 10:
                                return _context4.abrupt('return', response.data.map(function (person) {
                                    return new Person(person);
                                }));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getPeople(_x7) {
                return _ref4.apply(this, arguments);
            }

            return getPeople;
        }()

        /**
         * \brief   Get questions in the presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Question objects on success, else undefined
         */

    }, {
        key: 'getQuestions',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(presentationId) {
                var _this7 = this;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context6.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getQuestions - Invalid arguments");
                                return _context6.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getQuestions with presentation Id: ' + presentationId);

                                if (!this.cache.questions) {
                                    this.cache.questions = {};
                                }

                                if (!this.cache.questions[presentationId]) {
                                    this.cache.questions[presentationId] = [];
                                }

                                return _context6.abrupt('return', new _Promise(function (resolve, reject) {
                                    _this7.dlog.debug('get questions start');
                                    var limit = 100;
                                    var questions = _this7.cache.questions[presentationId];

                                    var getPartialQuestions = function () {
                                        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(offset) {
                                            var url, response, newQuestions;
                                            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                                while (1) {
                                                    switch (_context5.prev = _context5.next) {
                                                        case 0:
                                                            _this7.dlog.debug('get questions offset: ' + offset);
                                                            url = 'presentations/' + presentationId + '/questions?limit=' + limit;


                                                            if (offset != undefined) {
                                                                url += '&offset=' + offset;
                                                            }

                                                            _context5.next = 5;
                                                            return _this7.authenticatedRequest(url);

                                                        case 5:
                                                            response = _context5.sent;


                                                            if (response && response.data && response.data.questions) {
                                                                if (response.data.questions.length > 0) {
                                                                    newQuestions = response.data.questions;


                                                                    if (questions.length > 0) {
                                                                        newQuestions = response.data.questions.slice(1); // Remove first one as it is equal to the last one from a previous call
                                                                    }

                                                                    questions = questions.concat(newQuestions.map(function (question) {
                                                                        return new Question(question);
                                                                    }));
                                                                }

                                                                if (response.data.questions.length < limit) {
                                                                    _this7.cache.questions[presentationId] = questions;
                                                                    resolve(JSON.parse(_JSON$stringify(questions)));
                                                                } else {
                                                                    setTimeout(function () {
                                                                        getPartialQuestions(response.data.next);
                                                                    }, 1);
                                                                }
                                                            } else {
                                                                _this7.dlog.error('Unable to get the question in the presentation with Id: ' + presentationId);
                                                                reject('Unable to get the questions');
                                                            }

                                                        case 7:
                                                        case 'end':
                                                            return _context5.stop();
                                                    }
                                                }
                                            }, _callee5, _this7);
                                        }));

                                        return function getPartialQuestions(_x9) {
                                            return _ref6.apply(this, arguments);
                                        };
                                    }();

                                    getPartialQuestions(questions.length > 0 ? questions[questions.length - 1].id : undefined);
                                }));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function getQuestions(_x8) {
                return _ref5.apply(this, arguments);
            }

            return getQuestions;
        }()

        /**
         * \brief   Get messages between a user and his contact
         * \param[in] userId    Id of the user
         * \param[in] contactId    Id of the contact
         * \return Promise with array of Message objects on success, else undefined
         */

    }, {
        key: 'getMessages',
        value: function getMessages(userId, contactId) {
            var _this8 = this;

            if (userId === undefined || !contactId) {
                this.dlog.error("DLService.getMessages - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.getMessages between user: ' + userId + ' and contact: ' + contactId);

            if (!this.cache.messages) {
                this.cache.messages = {};
            }

            if (!this.cache.messages[userId]) {
                this.cache.messages[userId] = {};
            }

            if (!this.cache.messages[userId][contactId]) {
                this.cache.messages[userId][contactId] = [];
            }

            return new _Promise(function (resolve, reject) {
                _this8.dlog.debug('get Messages start');
                var limit = 100;
                var messages = _this8.cache.messages[userId][contactId];

                var getPartialMessages = function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(offset) {
                        var url, response;
                        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        _this8.dlog.debug('get Messages offset: ' + offset);
                                        url = 'user/' + userId + '/messages/contacts/' + contactId + '?limit=' + limit;


                                        if (offset != undefined) {
                                            url += '&offset=' + offset;
                                        }

                                        _context7.next = 5;
                                        return _this8.authenticatedRequest(url);

                                    case 5:
                                        response = _context7.sent;


                                        if (response && response.data && response.data.messages) {
                                            if (response.data.messages.length > 0) {
                                                messages = messages.concat(response.data.messages.map(function (message) {
                                                    return new Message(message);
                                                }));
                                            }

                                            if (response.data.messages.length < limit) {
                                                _this8.cache.messages[userId][contactId] = messages;
                                                resolve(JSON.parse(_JSON$stringify(messages)));
                                            } else {
                                                setTimeout(function () {
                                                    getPartialMessages(response.data.next);
                                                }, 1);
                                            }
                                        } else {
                                            _this8.dlog.error('Unable to get the messages between the user: ' + userId + ' and the contact: ' + contactId);
                                            reject('Unable to get the messages');
                                        }

                                    case 7:
                                    case 'end':
                                        return _context7.stop();
                                }
                            }
                        }, _callee7, _this8);
                    }));

                    return function getPartialMessages(_x10) {
                        return _ref7.apply(this, arguments);
                    };
                }();

                getPartialMessages(messages.length > 0 ? messages[messages.length - 1].messageId : undefined);
            });
        }

        /**
         * \brief   Get contacts of a user
         * \param[in] userId    Id of the user
         * \return Array of Contact objects on success, else undefined
         */

    }, {
        key: 'getContacts',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(userId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(userId === undefined)) {
                                    _context8.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getContacts - Invalid arguments");
                                return _context8.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getContacts of user: ' + userId);

                                _context8.next = 6;
                                return this.authenticatedRequest('user/' + userId + '/messages/contacts');

                            case 6:
                                response = _context8.sent;

                                if (!(!response || !response.data)) {
                                    _context8.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the contacts for the user Id: ' + userId);
                                return _context8.abrupt('return');

                            case 10:
                                return _context8.abrupt('return', response.data.map(function (contact) {
                                    return new Contact(contact);
                                }));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function getContacts(_x11) {
                return _ref8.apply(this, arguments);
            }

            return getContacts;
        }()

        /**
         * \brief   Get description of a survey within a presentation
         * \param[in] presentationId    Id of the presentation
         * \param[in] surveyId    Id of the survey
         * \return Survey object on success, else undefined
         */

    }, {
        key: 'getSurvey',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(presentationId, surveyId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(presentationId === undefined || !surveyId)) {
                                    _context9.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getSurvey - Invalid arguments");
                                return _context9.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getSurvey in presentation: ' + presentationId + ' with Id: ' + surveyId);

                                _context9.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/surveys/' + surveyId);

                            case 6:
                                response = _context9.sent;

                                if (response) {
                                    _context9.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the survey in the presentation with Id: ' + presentationId);
                                return _context9.abrupt('return');

                            case 10:
                                return _context9.abrupt('return', new Survey(response));

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getSurvey(_x12, _x13) {
                return _ref9.apply(this, arguments);
            }

            return getSurvey;
        }()

        /**
         * \brief   Get slides of a presentation
         * \param[in] presentationId    Id of the presentation
         * \return Array of Slide object on success, else undefined
         */

    }, {
        key: 'getSlides',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(presentationId) {
                var response;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(presentationId === undefined)) {
                                    _context10.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.getSlides - Invalid arguments");
                                return _context10.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.getSlides of presentation: ' + presentationId);

                                _context10.next = 6;
                                return this.authenticatedRequest('presentations/' + presentationId + '/slides');

                            case 6:
                                response = _context10.sent;

                                if (!(!response || !response.data)) {
                                    _context10.next = 10;
                                    break;
                                }

                                this.dlog.error('Unable to get the slides in the presentation with Id: ' + presentationId);
                                return _context10.abrupt('return');

                            case 10:
                                return _context10.abrupt('return', response.data.map(function (slide) {
                                    return new Slide(slide);
                                }));

                            case 11:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getSlides(_x14) {
                return _ref10.apply(this, arguments);
            }

            return getSlides;
        }()

        /**
         * \brief   Submit survey response
         * \param[in] presentationId    Id of the presentation
         * \param[in] surveyResponse    Responses from the survey
         * \return Promise
         */

    }, {
        key: 'submitSurvey',
        value: function submitSurvey(presentationId, surveyResponse) {
            if (presentationId === undefined || !surveyResponse) {
                console.log("DLService.submitSurvey - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.submitSurvey for presentation: ' + presentationId);

            return this.authenticatedRequest('presentations/' + presentationId + '/submitSurvey', 'POST', null, {
                payload: {
                    data: _JSON$stringify(surveyResponse),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Post a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] question  Question object
         * \return Promise
         */

    }, {
        key: 'postQuestion',
        value: function postQuestion(presentationId, userId, question) {
            if (presentationId === undefined || !userId || !question) {
                this.dlog.error("DLService.postQuestion - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.postQuestion with Id: ' + question.id + ' in presentation Id: ' + presentationId + ' from user Id: ' + userId);

            return this.authenticatedRequest('presentations/' + presentationId + '/questions', 'POST', null, {
                payload: {
                    data: _JSON$stringify({
                        Question: question,
                        PersonId: userId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Reply to a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] questionId    Id of the question
         * \param[in] reply    String of the reply
         * \return Promise
         */

    }, {
        key: 'replyQuestion',
        value: function replyQuestion(presentationId, userId, questionId, reply) {
            if (presentationId === undefined || userId === undefined || questionId === undefined || reply === undefined) {
                this.dlog.error("DLService.replyQuestion - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.replyQuestion with presentation Id: ' + presentationId + ' and question Id: ' + questionId + ' from user Id: ' + userId);

            var question = {
                id: questionId,
                props: {}
            };

            question.props[Identifier.guid()] = {
                timestamp: Date.now(),
                replyBy: userId,
                comment: reply
            };

            return this.authenticatedRequest('presentations/' + presentationId + '/question/' + questionId, 'POST', null, {
                payload: {
                    data: _JSON$stringify(question),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Post a message from a user to its contact
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user
         * \param[in] userId    Id of the contact
         * \param[in] message  Message object
         * \return Promise
         */

    }, {
        key: 'postMessage',
        value: function postMessage(presentationId, userId, contactId, message) {
            if (presentationId === undefined || userId === undefined || contactId === undefined || !message) {
                this.dlog.error("DLService.postMessage - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.postMessage in presentation Id: ' + presentationId + ' from user Id: ' + userId + ' to contact Id: ' + contactId);

            return this.authenticatedRequest('user/' + userId + '/messages', 'POST', null, {
                payload: {
                    data: _JSON$stringify({
                        message: message,
                        from: userId,
                        to: contactId,
                        presId: presentationId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Disconnect user from social media
         * \param[in] userId    Id of the user
         * \param[in] socialMedia    Social media to disconnect the user from. Valid values are: LinkedIn, Twitter, Facebook
         * \return Promise
         */

    }, {
        key: 'unlinkAccount',
        value: function unlinkAccount(userId, socialMedia) {
            if (userId === undefined || !socialMedia) {
                this.dlog.error("DLService.unlinkAccount - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.unlinkAccount with user Id: ' + userId + ' from ' + socialMedia);

            return this.authenticatedRequest('user/' + userId + '/unlink?provider=' + socialMedia, 'POST', null);
        }

        /**
         * \brief   Like a question
         * \param[in] presentationId    Id of the presentation
         * \param[in] userId    Id of the user who likes the question
         * \param[in] questionId    Id of the question
         * \return Promise
         */

    }, {
        key: 'likeQuestion',
        value: function likeQuestion(presentationId, userId, questionId) {
            if (presentationId === undefined || userId === undefined || questionId === undefined) {
                this.dlog.error("DLService.likeQuestion - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.likeQuestion with presentation Id: ' + presentationId + ' between user Id: ' + userId + ' and question Id: ' + questionId);

            return this.authenticatedRequest('presentations/' + presentationId + '/question/' + questionId + '/like', 'POST', null, {
                payload: {
                    data: _JSON$stringify({
                        VoteFor: true,
                        Id: questionId,
                        PersonId: userId
                    }),
                    type: 'application/json; charset=UTF-8'
                }
            });
        }

        /**
         * \brief   Like a slide
         * \param[in] presentationId    Id of the presentation
         * \param[in] slideId    Id of the slide
         * \return Promise
         */

    }, {
        key: 'likeSlide',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(presentationId, slideId) {
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(presentationId === undefined || slideId === undefined)) {
                                    _context11.next = 3;
                                    break;
                                }

                                this.dlog.error("DLService.likeSlide - Invalid arguments");
                                return _context11.abrupt('return', _Promise.reject("Invalid arguments"));

                            case 3:

                                this.dlog.debug('DLService.likeSlide with presentation Id: ' + presentationId + ' and slide Id: ' + slideId);

                                return _context11.abrupt('return', this.authenticatedRequest('presentations/' + presentationId + '/slide/' + slideId + '/like', 'POST', null, {
                                    payload: {
                                        data: _JSON$stringify({
                                            vote: true,
                                            id: slideId
                                        }),
                                        type: 'application/json; charset=UTF-8'
                                    }
                                }));

                            case 5:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function likeSlide(_x15, _x16) {
                return _ref11.apply(this, arguments);
            }

            return likeSlide;
        }()

        /**
         * \brief   Join a user to a presentation
         * \param[in] presentationId    Id of the presentation
         * \param[in] user    User object
         * \return Promise
         */

    }, {
        key: 'joinPresentation',
        value: function joinPresentation(presentation, user) {
            var _this9 = this;

            if (presentation === undefined || presentation.id === undefined || presentation.websocket === undefined || !user) {
                this.dlog.error("DLService.joinPresentation - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            this.dlog.debug('DLService.joinPresentation ' + user.id + ' in presentation Id: ' + presentation.id);

            return new _Promise(function (resolve, reject) {
                _this9.authenticatedRequest('presentations/' + presentation.id + '/people', 'POST', null, {
                    payload: {
                        data: _JSON$stringify(user),
                        type: 'application/json; charset=UTF-8'
                    }
                }).then(function () {
                    if (_this9.broadcastman) {
                        _this9.broadcastman.destroy();
                    }

                    _this9.broadcastman = new BroadcastManager(_this9.apiOptions.host, presentation, _this9.apiOptions.auth, _this9.dlog);

                    var updateCache = function updateCache(question) {
                        if (_this9.cache.questions === undefined || _this9.cache.questions[presentation.id] === undefined) {
                            return;
                        }

                        for (var i = 0; i < _this9.cache.questions[presentation.id].length; ++i) {
                            if (_this9.cache.questions[presentation.id][i].id === question.id) {
                                _this9.cache.questions[presentation.id][i].merge(question);
                                break;
                            }
                        }
                    };

                    _this9.broadcastman.addListener('questionPropsUpdated', updateCache);
                    _this9.broadcastman.addListener('questionLiked', updateCache);

                    resolve();
                }).catch(reject);
            });
        }

        /**
         * \brief   Analytics: Post tracking data. TODO: Refactor
         * \param[in] data    Json data to post
         * \return Promise
         */

    }, {
        key: 'postLead',
        value: function postLead(data) {
            if (!data) {
                this.dlog.error("DLService.postLead - Invalid arguments");
                return _Promise.reject("Invalid arguments");
            }

            var leadGenAccessKey = 'WtzemScOj95LSsM4hXupB7XmZCtfBYHN6In1Q0k2';
            var url = 'https://tyza0aojfd.execute-api.us-east-1.amazonaws.com/test/leadgen';
            var xhrp = new XHRPromise('POST', url);
            xhrp.addPayload(data, 'application/json; charset=UTF-8');
            xhrp.addHeaders({
                'x-api-key': leadGenAccessKey
            });

            return xhrp.createAndSend();
        }

        /**
         * \brief   Register listener for event. DLService.setupListeners must be called before using this api.
         * \param[in] eventName   Event name to listen. Value can be on of the following: 
         *                        attendeeJoined, attendeeLeft, surveyStarted, surveyStopped, slidesUploaded,
         *                        slideUploaded, slideChanged, slideDeleted, presentationUpdated, presentationDeleted,
         *                        questionAdded, questionLiked, questionPropsUpdated, 1001, 1002, 1003
         * \param[in] callback    Callback when receiving the event
         * \return  Event object Id. Use to remove the listener.
         */

    }, {
        key: 'addEventListener',
        value: function addEventListener(eventName, callback) {
            if (!eventName || !callback) {
                this.dlog.error("DLService.addEventListener - Invalid arguments");
                return;
            }

            this.dlog.debug('DLService.addEventListener with eventName: ' + eventName);

            if (this.broadcastman) {
                this.broadcastman.addListener(eventName, callback);
            } else {
                this.dlog.error("DLService.addEventListener - Uninitialized broadcastmanager. Make sure to call DLService.setupListeners before DLService.addEventListener");
            }
        }

        /**
         * \brief   Unregister listener for event.
         * \param[in] eventObjectId   Event object id returned by DLService.addEventListener
         */

    }, {
        key: 'removeEventListener',
        value: function removeEventListener(eventObjectId) {
            if (!eventObjectId || !eventObjectId.eventName) {
                this.dlog.error("DLService.removeEventListener - Invalid arguments");
                return;
            }

            this.dlog.debug('DLService.removeEventListener with eventName: ' + eventObjectId.eventName);

            if (this.broadcastman) {
                this.broadcastman.removeListener(eventObjectId);
            } else {
                this.dlog.error("DLService.removeEventListener - Uninitialized broadcastmanager. Make sure to call DLService.setupListeners before DLService.addEventListener");
            }
        }

        /**
         * \brief   Tweet information about a slide
         * \param[in] tweet   tweet object to describe slide.
         */

    }, {
        key: 'tweetSlide',
        value: function tweetSlide(tweet, user) {
            if (!tweet || !user || !user.token) {
                this.dlog.error("DLService.tweetSlide - Invalid arguments");
                return;
            }

            var xmlhttp = new XMLHttpRequest();

            xmlhttp.oTweet = tweet;
            xmlhttp.open('POST', 'https://' + this.apiOptions.host + '/v1/tweet');
            xmlhttp.setRequestHeader('Authorization', 'Bearer ' + user.token);
            xmlhttp.send(_JSON$stringify(tweet));
        }

        // ************************************************************************
        //
        //                               PRIVATE
        //
        // ************************************************************************

        /**
         * \brief   Send authenticated request. User must be logged in before send api requests
         * \param[in] url   API url
         * \param[in] method    Method for url. Default: GET
         * \param[in] responseType  Fomrat of the response. Default: JSON
         * \return  Promise
         */

    }, {
        key: 'authenticatedRequest',
        value: function authenticatedRequest(url) {
            var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
            var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'JSON';
            var extraParams = arguments[3];

            if (!this.apiOptions || !this.apiOptions.auth) {
                this.dlog.error("DLService.authenticatedRequest - User not logged in");
                return _Promise.reject("User not logged in");
            }

            var host = extraParams && extraParams.host ? extraParams.host : 'https://' + this.apiOptions.host;
            var xhrp = new XHRPromise(method, host + '/' + this.apiOptions.version + '/' + url);

            xhrp.setResponseType(responseType);
            xhrp.addHeaders({
                'Authorization': this.apiOptions.auth
            });

            this.dlog.debug('DLService.authenticatedRequest: ' + method + ' ' + host + '/' + this.apiOptions.version + '/' + url + ' (response: ' + responseType + ')');

            if (extraParams !== undefined) {
                if (extraParams.params) {
                    xhrp.addParams(extraParams.params);
                }

                if (extraParams.headers) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = _getIterator(extraParams.headers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var header = _step.value;

                            xhrp.addHeaders(header);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }

                if (extraParams.payload) {
                    xhrp.addPayload(extraParams.payload.data, extraParams.payload.type);
                }
            }

            return xhrp.createAndSend();
        }

        /**
         * \brief   Get login url for social network
         * \param[in] socialNetwork     Social network associated to login url: linked, twitter, facebook
         * \return Login url
         */

    }, {
        key: 'getLoginUrl',
        value: function getLoginUrl(socialNetwork, url) {
            socialNetwork = socialNetwork.toLowerCase();

            if (socialNetwork !== 'linkedin' && socialNetwork !== 'twitter' && socialNetwork !== 'facebook') {
                this.dlog.error('DLService.getLoginUrl: Invalid argument: ' + socialNetwork);
                return;
            }

            var params = Url.paramsArray(Url.removeParam(url, "error_code"));

            params.push(this.getRdParameter());

            var cloneArgs = '?' + params.join('&');

            this.dlog.debug('DLService.getLoginUrl: https://' + this.apiOptions.host + '/auth/' + socialNetwork + cloneArgs);

            return 'https://' + this.apiOptions.host + '/auth/' + socialNetwork + cloneArgs;
        }

        /**
         * \brief Get rd parameter
         * \return String RD parameter
         */

    }, {
        key: 'getRdParameter',
        value: function getRdParameter() {
            var rd = void 0;

            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                rd = 7;
            } else {
                rd = 8;
            }

            return 'rd=' + rd;
        }
    }]);

    return DLService;
}();

export default DLService;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/index.js
// module id = 506
// module chunks = 0